
export const useHandleKeyUp = (handleSearch, tempSearchResult, recentSearches, searchText, setSearchText, setSelectedMenu, alternatives, setRecentQueryParams, enhancedSuggestions?) => {
  // Tracking of key up, key down and enter event
  const handleKeyUp = event => {
    event.persist();
    if (event.keyCode === 13) {
      handleSearch();
      return;
    }

    const { suggestions } = tempSearchResult || {};
    const suggestionsCategories = suggestions && suggestions.categories ? suggestions.categories : [];
    const max = suggestionsCategories.length - 1;
    const recentMax = recentSearches && recentSearches.length > 0 ? recentSearches.length - 1 : 0;

    if (searchText.trim() === "" && (!recentSearches || recentSearches.length === 0)) return;

    setSelectedMenu(state => {
      // If you press shift, control, option or command on any suggestion it will
      // return you to first one so we are preventing that behavior not to happen
      if (
        event.keyCode === 16 ||
        event.keyCode === 17 ||
        event.keyCode === 18 ||
        event.keyCode === 91 ||
        event.keyCode === 93
      )
        return state;

      // Key up
      if (event.keyCode === 38) {
        // If an alternative is shown, do not move the cursor up
        if (suggestions && suggestions.notFound && alternatives && alternatives[0]) {
          setSearchText(alternatives[0]);
          return -1;
        }

        // If no text is entered, move the cursor in the recent search
        if (searchText == "") {
          if (state == 0 || state == -1) {
            setRecentQueryParams({ text: recentSearches[recentMax].text, url: recentSearches[recentMax].url, isAi: recentSearches[recentMax].isAi });
            return recentMax;
          } else {
            setRecentQueryParams({
              text: recentSearches[state - 1].text,
              module: recentSearches[state - 1].module,
              category: recentSearches[state - 1].category,
              url: recentSearches[state - 1].url,
              isAi: recentSearches[state - 1].isAi
            });
            return state - 1;
          }

          // And if the text is entered, then move the cursor according to the suggestions
        } else if (searchText.trim().length > 2) {
          if (suggestionsCategories.length == 0) return -1;
          if (state == -1) {
            return max;
          } else {
            return state - 1;
          }
        }
      }

      // Key down
      if (event.keyCode === 40) {
        // If an alternative is shown, do not move the cursor down
        if (suggestions && suggestions.notFound && alternatives && alternatives[0]) {
          setSearchText(alternatives[0]);
          return -1;
        }

        // If no text is entered, move the cursor in the recent search
        if (searchText == "") {
          if (state == recentMax) {
            setRecentQueryParams({ text: recentSearches[0].text, url: recentSearches[0].url, isAi: recentSearches[0].isAi });
            return 0;
          } else {
            setRecentQueryParams({
              text: recentSearches[state + 1].text,
              module: recentSearches[state + 1].module,
              category: recentSearches[state + 1].category,
              url: recentSearches[state + 1].url,
              isAi: recentSearches[state + 1].isAi
            });
            return state + 1;
          }

          // And if the text is entered, then move the cursor according to the suggestions
        } else if (searchText.trim().length > 2) {
          if (suggestionsCategories.length == 0) return -1;
          if (state == max) {
            return -1;
          } else {
            return state + 1;
          }
        }
      }
      return -1;
    });
  };

  return handleKeyUp
}


// WEBPACK FOOTER //
// ./src/containers/HomePage/hooks/useHandleKeyUp.ts